
































import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import BaseComments from '@/components/common/BaseComments.vue'
import BaseImage from '@/components/common/BaseImage.vue'
import BaseSocialSharing from '@/components/common/BaseSocialSharing.vue'
import _filter from 'lodash/filter'

@Component( {
    computed: mapGetters( {
        currentImage: 'imagesModule/currentImage',
        associationById: 'associationsModule/associationById',
        userByUid: 'usersModule/userByUid'
    } ),
    components: {
        'oe-base-comments': BaseComments,
        'oe-base-image': BaseImage,
        'oe-base-social-sharing': BaseSocialSharing
    }
} )
export default class SourceDetailOverlay extends Vue {
    sourceDetailActive = false
    associationById!: any
    currentImage: any

    get filteredAssociations() {
        return _filter( this.currentImage.relatedAssociations, ( association ) => {
            if ( this.associationById( association ) ) {
                return this.associationById( association ).language === this.$i18n.locale
                    && this.associationById( association ).published
                    && this.associationById( association ).relatedImage === this.currentImage.id
            }
        } )
    }

    showOverlay() {
        this.sourceDetailActive = true
        this.$store.commit( 'globalModule/setBodyFixed' )
    }

    closeOverlay( event: Event ) {
        event.preventDefault()

        this.sourceDetailActive = false
        this.$store.commit( 'globalModule/setBodyFixed' )
    }
}
